// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React, { useContext } from "react";

import {
  AppBar,
  Box,
  IconButton,
  styled,
  Toolbar as GobanToolbar,
} from "@3778.care/goban";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useLocation } from "react-router";

import { DrawerContext } from "../../contexts/drawer";
import { Logo } from "../index";
import { useGetButtons } from "./buttons";
import { PathButton } from "./PathButton";

const Grow = styled(Box)(() => ({
  flexGrow: 1,
}));

const CircleIcon = styled(AccountCircleIcon)(({ theme: { palette } }) => ({
  fontSize: 34,
  color: palette.text.secondary,
}));

export const Toolbar = () => {
  const { pathname } = useLocation();
  const { toggleDrawer } = useContext(DrawerContext);

  const buttons = useGetButtons({ isDesktop: true, pathname });

  return (
    <AppBar color="inherit">
      <GobanToolbar>
        <Logo data-cy="logo" />

        {buttons.map((button) => (
          <PathButton
            isActive={button.value === pathname || button.path?.test(pathname)}
            key={button.value}
            to={button.value}
            tour={button.tour}
          >
            {button.label}
          </PathButton>
        ))}

        <Grow />

        {toggleDrawer && (
          <IconButton
            color="secondary"
            data-cy="personal-drawer-button"
            onClick={toggleDrawer}
            size="small"
          >
            <CircleIcon />
          </IconButton>
        )}
      </GobanToolbar>
    </AppBar>
  );
};
